export default "__VITE_ASSET__CetmAPer__"